module.exports = __webpack_public_path__ + "static/media/L8.470c8ca0.jpg";